import script from "./NhapKhoVatTuPhuTung.vue?vue&type=script&lang=ts&setup=true"
export * from "./NhapKhoVatTuPhuTung.vue?vue&type=script&lang=ts&setup=true"

import "./NhapKhoVatTuPhuTung.vue?vue&type=style&index=0&id=d06f45a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d06f45a2"]])

export default __exports__